import { useNavigate } from "@core/routing/use-navigate";
import { RoutesPath } from "@ui/navigation/routes";
import { isNotNil } from "@utils/assert";
import React, { useEffect } from "react";
import { useLocation } from "react-router";

export default function VipLoginRedirectionPage(): JSX.Element {
	const location = useLocation();
	const navigate = useNavigate();
	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const { veevaid: veevaId, ...otherParams } = Object.fromEntries(searchParams.entries());
		if (isNotNil(veevaId)) {
			// We cast otherParams as undefined because we don't expect any query params for the VipLogin page.
			// Nonetheless, we want to pass any potential query params to the VipLogin.
			navigate(RoutesPath.VipLogin, { route: { veevaId }, query: otherParams as unknown as undefined });
		} else {
			navigate(RoutesPath.Register);
		}
	}, [location.search, navigate]);
	return <></>;
}
